import { useEffect, useState } from "react";
import { ResultListFrmDto } from "../api/Dtos";
import { useGlobalContext } from "../Layout/GlobalState";
import { GET } from "../api/BackendApi";

export function useResultListFrmFromBackend() {
  const globalContext = useGlobalContext();
  const [resultListFrm, setResultListFrm] = useState<Array<ResultListFrmDto>>([]);
  const [loading, setLoading] = useState<boolean>(false);

  // Get ResultLists from backend
  useEffect(() => {
    if (globalContext.competition) {
      setLoading(true);
      GET.allResultRptListsInCompetition(globalContext.competition.tag).then(
        (resultListsFrm: Array<ResultListFrmDto>) => {
          setResultListFrm(resultListsFrm);
        }
      ).catch((error) => {
        console.error('Error fetching result lists:', error);
      }).finally(() => {
        setLoading(false);
      });
    }
  }, [globalContext.competition]);

  return { resultListFrm, setResultListFrm, loading };
}

export function resultListFrmService() {
  const [resultListFrm, setResultListFrm] = useState<Array<ResultListFrmDto>>([]);
  const globalContext = useGlobalContext();

  const fetchResultListFrm = async (): Promise<ResultListFrmDto[]> => {
    try {
      if (globalContext.competition) {
        const resultListFrm = await GET.allResultRptListsInCompetition(globalContext.competition.tag);
        return resultListFrm;
      } else {
        return [];
      }
    }
    catch (error) {
      console.error('Error fetch all resultListsByCompetitionTag: ', error);
      throw error;
    }
  };

  const GetResultListFrm = async () => {
    try {
      const resultListFrm: ResultListFrmDto[] = await fetchResultListFrm();
      return resultListFrm;
    } catch (error) {
      console.error('Error fetch all resultListsByCompetitionTag: ', error);
      throw error;
    }
  };

  return { resultListFrm: GetResultListFrm };
};
